module.exports = __webpack_public_path__ + "static/img/times-svgrepo-com (1).3c8e8803.svg";